export const environment = {
    production: false,
    envName: "test",
    autoSignIn: true,
    popupForLogin: false,
    cacheLocation: "localStorage",
    instance: "https://login.microsoftonline.com/",
    tenantId: "fd799da1-bfc1-4234-a91c-72b3a1cb9e26",
    clientId: '90125c61-e0b1-4d04-b24c-b058940452d7',
    redirectUri: 'https://mpviewertest.azure.chevron.com',
    oidcScopes: ["openid", "profile", "User.Read","offline_access"],
    graphScopes: ["User.Read", "User.Read.All"],
    appApiURL: 'https://mpviewer-api-test.azure.chevron.com/api/v1/',
    graphApiURL: 'https://graph.microsoft.com',
};
